// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// locales
import ThemeLocalization from "./locales";
// components
import SnackbarProvider from "./components/snackbar";
import { ThemeSettings } from "./components/settings";
import { MotionLazyContainer } from "./components/animate";
import * as Sentry from "@sentry/react";

// ----------------------------------------------------------------------
// import TagManager from 'react-gtm-module'
//
// const tagManagerArgs = {
//   gtmId: 'GTM-5L2L8W9D'
// }
//
// TagManager.initialize(tagManagerArgs)

// ----------------------------------------------------------------------
Sentry.init({
  dsn: "https://97a44dc10f218c324eb80c1488ac9680@o4506376939569152.ingest.us.sentry.io/4506396237430784",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <ThemeLocalization>
            <SnackbarProvider>
              <Sentry.ErrorBoundary
                fallback={({ error, componentStack, resetError }) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                      textAlign: "center",
                      fontFamily: "sans-serif",
                    }}
                  >
                    <h2>Something went wrong</h2>
                    <p style={{ maxWidth: 400, color: "#666" }}>
                      We're sorry, but an unexpected error has occurred. Please
                      try reloading the page.
                    </p>
                    <button
                      onClick={() => window.location.reload()}
                      style={{
                        marginTop: 20,
                        padding: "10px 20px",
                        fontSize: "16px",
                        cursor: "pointer",
                        background: "#007BFF",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                      }}
                    >
                      Reload Page
                    </button>
                  </div>
                )}
              >

                <Router />
              </Sentry.ErrorBoundary>
            </SnackbarProvider>
          </ThemeLocalization>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
